import { apiClient } from './client';

/**
 * Fetches the preview image for a model file.
 * GET /api/v1/model-files/{model_file_id}/preview
 */
export const getModelFilePreview = async (modelFileId: string): Promise<Blob> => {
  const response = await apiClient.get(`/model-files/${modelFileId}/preview`, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * Downloads a model file by ID.
 * GET /api/v1/model-files/{model_file_id}/download
 */
export const downloadModelFile = async (modelFileId: string): Promise<Blob> => {
  const response = await apiClient.get(`/model-files/${modelFileId}/download`, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * Deletes a model file by ID.
 * DELETE /api/v1/model-files/{model_file_id}
 */
export const deleteModelFile = async (modelFileId: string): Promise<void> => {
  await apiClient.delete(`/model-files/${modelFileId}`);
};
